/**
 * Round a number to a specified number of decimal places.
 *
 * @param value The number to round.
 * @param decimals The number of decimal places to round to. Defaults to `2`.
 */
export const round = (value: number, decimals = 2) => {
  const multiplier = Math.pow(10, decimals)
  return Math.round(value * multiplier) / multiplier
}
